<template>
  <div class="login">
    <!-- v-if="!dialogFormVisible" -->
    <!-- <el-dialog title="验证" :visible.sync="dialogFormVisible" width="30%" :show-close="false"
      :close-on-press-escape="false" :close-on-click-modal="false">
    
      <div slot="footer" class="dialog-footer flex justify-center">
        <el-button type="primary" @click="submmit()">确 定</el-button>
      </div>
    </el-dialog> -->

    <div class="">

      <div style="color: #fff;" class="text-center text-lg mb-6">已打开密码保护，请输入密码</div>
      <div class="flex items-center justify-center h-full">
        <el-input v-model="form.password" type="password" class="mr-2" @keyup.enter.native="submmit"
          style="width: 200px;" ref="pwdInput">
        </el-input>
        <el-button type="primary" @click="submmit()">确 定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { cloudLSDPermissionsAttest } from '@/api/home'
export default {
  components: {},
  data() {
    return {

      form: {
        password: '',
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.pwdInput.focus()
    })
  },
  methods: {
    async submmit() {
      if (this.form.password == '') {
        return this.$message.error('请输入密码')
      }

      const res = await cloudLSDPermissionsAttest({ password: this.form.password })
      if (res.code == 200) {
        this.dialogFormVisible = false
        sessionStorage.setItem('code', res.code)
        this.$router.push({ path: '/' })
      } else {
        this.$message.error('密码错误')
      }

    },

  }
}

</script>
<style>
.login {
  background: url(@/assets/img/login-bg.jpg);
  background-size: cover;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-form-item__label {
  color: #fff;
}
</style>